export default "__VITE_ASSET__5edda461__"